<script>
import { PolarArea } from "vue-chartjs";

export default {
  extends: PolarArea,
  props: {
    chartData: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      chartDataset: {
        labels: [
          "Africa",
          "Asia",
          "Europe",
          "North America",
          "Oceania",
          "South America"
        ],
        datasets: [
          {
            data: this.chartData,
            backgroundColor: [
              "#e62d2c",
              "#808080",
              "#000000",
              "#e6e6e6",
              "#646464",
              "#fc8484"
            ],
            borderWidth: 0
          }
        ]
      },
      chartOptions: {
        layout: {
          padding: 30
        },
        legend: {
          display: false
        },
        onClick: this.selectContinent,
        onHover: function(e) {
          let point = this.getElementAtEvent(e);
          if (point.length) e.target.style.cursor = "pointer";
          else e.target.style.cursor = "default";
        },
        tooltips: {
          enabled: false
        },
        scale: {
          ticks: {
            beginAtZero: true,
            callback: function() {
              return "";
            },
            backdropColor: "rgba(0, 0, 0, 0)"
          }
        },
        plugins: {
          datalabels: {
            display: c => {
              let index = c.dataIndex;
              let value = c.dataset.data[index];
              return value != 0;
            },
            formatter: (value, context) => {
              return (
                context.chart.data.labels[context.dataIndex] + "\n" + value
              );
            },
            align: "end",
            offset: c => {
              let chart = c.chart;
              let meta = chart.getDatasetMeta(c.datasetIndex);
              let model = meta.data[c.dataIndex]._model;
              return model.outerRadius / 2;
            }
          }
        }
      }
    };
  },
  methods: {
    selectContinent(event, array) {
      let clickedId = array[0]["_index"] + 1;
      let index = this.$store.state.filters.continent.indexOf(clickedId);
      if (index > -1) this.$store.state.filters.continent.splice(index, 1);
      else this.$store.state.filters.continent.push(clickedId);
    }
  },
  mounted() {
    this.renderChart(this.chartDataset, this.chartOptions);
  },
  watch: {
    chartData() {
      this.chartDataset.datasets[0].data = this.chartData;
      this.$data._chart.update();
    }
  }
};
</script>